import { UPDATE_RELATED_PROPERTIES } from './actions';

export default (previousState = [], { type, data }) => {
  switch (type) {
    case UPDATE_RELATED_PROPERTIES:
      return data;
    default:
      return previousState;
  }
};